export default "__VITE_ASSET__deb1c7f2__"